const audioBlocks = document.querySelectorAll(".js-audio");

const calculateTime = (secs) => {
    const minutes = Math.floor(secs / 60);
    const seconds = Math.floor(secs % 60);
    const returnedSeconds = seconds < 10 ? `0${seconds}` : `${seconds}`;
    return `${minutes}:${returnedSeconds}`;
};

if (typeof audioBlocks != "undefined" && audioBlocks != null) {
    audioBlocks.forEach((block) => {
        const btn = block.querySelector(".js-audio-btn");
        const audioFile = block.querySelector(".js-audio-el");
        const currentTimeContainer = block.querySelector(".js-audio-curr");
        const durationContainer = block.querySelector(".js-audio-dur");
        const seekSlider = block.querySelector(".js-audio-slider");
        const playIcon = block.querySelector(".js-audio-play-icon");
        const pauseIcon = block.querySelector(".js-audio-pause-icon");
        let playState = "play";
        let raf = null;

        //helper funcs
        const displayDuration = () => {
            durationContainer.textContent = calculateTime(audioFile.duration);
        };

        const setSliderMax = () => {
            seekSlider.max = Math.floor(audioFile.duration);
        };

        const whilePlaying = () => {
            seekSlider.value = Math.floor(audioFile.currentTime);
            currentTimeContainer.textContent = calculateTime(seekSlider.value);
            block.style.setProperty(
                "--seek-before-width",
                `${(seekSlider.value / seekSlider.max) * 100}%`
            );
            raf = requestAnimationFrame(whilePlaying);
        };

        const showRangeProgress = (rangeInput) => {
            block.style.setProperty(
                "--seek-before-width",
                (rangeInput.value / rangeInput.max) * 100 + "%"
            );
        };

        //set max and duration
        if (audioFile.readyState > 0 && seekSlider) {
            if (seekSlider) {
                setSliderMax();
                displayDuration();
            }
        } else {
            audioFile.addEventListener("loadedmetadata", () => {
                if (seekSlider) {
                    displayDuration();
                    setSliderMax();
                }
            });
        }

        //update if range changes
        if (seekSlider) {
            seekSlider.addEventListener("input", (e) => {
                currentTimeContainer.textContent = calculateTime(seekSlider.value);
                audioFile.currentTime = seekSlider.value;
                if (!audioFile.paused) {
                    requestAnimationFrame(whilePlaying);
                    cancelAnimationFrame(raf);
                }
                showRangeProgress(e.target);
            });
        }


        //play btn
        btn.addEventListener("click", () => {
            if (playState === "play") {
                audioFile.play();
                playState = "pause";
                if (seekSlider) {
                    requestAnimationFrame(whilePlaying);
                }
                gsap.to(playIcon, {
                    autoAlpha: 0,
                    duration: 0.1
                })
                gsap.to(pauseIcon, {
                    autoAlpha: 1,
                    duration: 0.1
                })
            } else {
                audioFile.pause();
                playState = "play";
                if (seekSlider) {
                    cancelAnimationFrame(raf);
                }
                gsap.to(playIcon, {
                    autoAlpha: 1,
                    duration: 0.1
                })
                gsap.to(pauseIcon, {
                    autoAlpha: 0,
                    duration: 0.1
                })
            }
        });
    });
}